import { render, staticRenderFns } from "./PasswordForgottenForm.vue?vue&type=template&id=1276202c"
import script from "./PasswordForgottenForm.vue?vue&type=script&lang=js"
export * from "./PasswordForgottenForm.vue?vue&type=script&lang=js"
import style0 from "./PasswordForgottenForm.vue?vue&type=style&index=0&id=1276202c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports